program houseOversite;

uses
  Vcl.Forms,
  WEBLib.Forms,
  Unit1 in 'Unit1.pas'{*.html},
  login in 'login.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.Run;
end.
